import React from 'react'

import TabNav from '../components/TabNav/TabNav'
import UserCard from '../components/UserCard/UserCard'
import ProfileVacancies from '../components/ProfileVacancies/ProfileVacancies'
import AppliedJobs from '../components/ProfileVacancies/AppliedJobs'
import { profilePaths } from '../constants/constans'

const title = window.location.pathname === profilePaths.vacancies ? 'Job search' : 'Job Vacancies'

const links = [
  {
    url: profilePaths.vacancies,
    title,
    component: ProfileVacancies,
  },
  {
    url: profilePaths.applied_jobs,
    title: 'Applied Jobs',
    component: AppliedJobs,
  },
]

const UserPage = () => {
  return <TabNav title='Vacancies' links={links} redirectLink={profilePaths.vacancies} />
}

export default UserPage
